/**
 * Experience Components
 * Exports all experience-related components
 */

export { ExperienceCard } from './ExperienceCard';
export { SmallExperienceCard } from './SmallExperienceCard';
export { NexgoExperiencesSection } from './NexgoExperiencesSection';
export { ExperiencesLoadingPlaceholder } from './ExperiencesLoadingPlaceholder';

// Export types
export type { ExperienceCardProps } from './ExperienceCard';
export type { SmallExperienceCardProps } from './SmallExperienceCard';
export type { NexgoExperiencesSectionProps } from './NexgoExperiencesSection';
export type { ExperiencesLoadingPlaceholderProps } from './ExperiencesLoadingPlaceholder';

// Export utilities
export { getExperienceBadgeConfig } from './utils/experienceBadgeConfig';
export type {
  ExperienceType,
  BadgeConfig,
} from './utils/experienceBadgeConfig';
